import React, { HTMLAttributes } from "react";
import PropTypes from "prop-types";

/** Data provider */
import pubsub from "global/global";
import CustomEvent from "core/customEvent";

import MessageBox from "component/molecules/messageBox/index";

interface IMessageBoxContainerProps {}
interface IMessageBoxContainerStates {
  isMessageBoxOpen: boolean;
  title: string;
  message: string;
  buttonType: any;
  hasCloseButton: boolean;
  hasTodayOffButton: boolean;
  handleYesClick: any;
  handleNoClick: any;
}

class MessageDialogContainer extends React.Component<
  IMessageBoxContainerProps,
  IMessageBoxContainerStates
> {
  static propTypes: PropTypes.InferProps<IMessageBoxContainerProps>;

  /**
   * default property values
   *
   * @static
   * @memberof Viewport
   */
  static defaultProps = {};

  constructor(props: any) {
    super(props);

    this.state = {
      isMessageBoxOpen: false,
      hasTodayOffButton: false,
      title: "",
      message: "",
      buttonType: "CLOSE",
      hasCloseButton: false,
      handleYesClick: null,
      handleNoClick: null,
    };
  }

  componentDidMount = () => {
    (pubsub as any).subscribe(
      CustomEvent.Messages.OPEN_MESSAGE_BOX,
      this.handleOpenMessageBox
    );
  };

  componentWillUnmount = () => {
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.OPEN_MESSAGE_BOX,
      this.handleOpenMessageBox
    );
  };

  handleOpenMessageBox = (payload: any, msg: any) => {
    const {
      title,
      message,
      buttonType,
      hasCloseButton,
      hasTodayOffButton,
      handleYesClick,
      handleNoClick,
    } = payload;

    this.setState({
      title: title,
      message: message,
      buttonType: buttonType,
      hasCloseButton: hasCloseButton,
      isMessageBoxOpen: true,
      hasTodayOffButton: hasTodayOffButton,
      handleYesClick: handleYesClick,
      handleNoClick: handleNoClick,
    });
  };

  render = () => {
    const {
      isMessageBoxOpen,
      title,
      message,
      buttonType,
      hasCloseButton,
      hasTodayOffButton,
      handleYesClick,
      handleNoClick,
    } = this.state;
    return (
      <>
        <MessageBox
          open={isMessageBoxOpen}
          title={title}
          message={message}
          buttonType={buttonType}
          hasCloseButton={hasCloseButton}
          hasTodayOffButton={hasTodayOffButton}
          onClose={() => {
            this.setState({ isMessageBoxOpen: false });
          }}
          onYes={handleYesClick}
          onNo={handleNoClick}
        />
      </>
    );
  };
}

export default MessageDialogContainer;
